import axios from 'axios';
import authHeader from '@/services/auth-header';

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api`;
const version = 'v2';
const main = 'Intranet';
const sub = 'Announcements';

// {
//   "announcementId": 0,
//   "title": "string",
//   "content": "string",
//   "textType": "string",
//   "userName": "string",
//   "created": "2025-10-30T03:11:31.212Z",
//   "updated": "2025-10-30T03:11:31.212Z",
//   "expired": "2025-10-30T03:11:31.212Z",
//   "views": 0,
//   "category": "string",
//   "isPublished": true,
//   "attachments": "string",
//   "deleted": true
// }

class AnnouncementService {
  getAnnouncements() {
    return axios.get(`${API_URL}/${version}/${main}/${sub}`, {
      headers: authHeader(),
    });
  }

  getAnnouncementById(announcementId) {
    return axios.get(`${API_URL}/${version}/${main}/${sub}/${announcementId}`, {
      headers: authHeader(),
    });
  }

  createAnnouncement(announcement) {
    return axios.post(`${API_URL}/${version}/${main}/${sub}`, announcement, {
      headers: authHeader(),
    });
  }

  updateAnnouncement(announcementId, announcement) {
    return axios.put(`${API_URL}/${version}/${main}/${sub}/${announcementId}`, announcement, {
      headers: authHeader(),
    });
  }

  deleteAnnouncement(announcementId) {
    return axios.delete(`${API_URL}/${version}/${main}/${sub}/Remove/${announcementId}`, {
      headers: authHeader(),
    });
  }

  checkAnnouncementAdmin() {
    return axios.get(`${API_URL}/${version}/${main}/${sub}/CheckAnnouncementAdmin`, {
      headers: authHeader(),
    });
  }

  downloadAttachment(fileKey) {
    return axios.get(`${API_URL}/${version}/${main}/${sub}/Download`, {
      params: {
        fileKey: fileKey,
      },
      headers: authHeader(),
      responseType: 'blob',
    });
  }
}

export default new AnnouncementService();
